﻿import config from "../config"
const baseUrl = config.base_url + "temp_image_text/"
export default {
    list: {
        url:  baseUrl + "list",
        type: "get",
    },
    page: {
        url:  baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    remove:{
        url:  baseUrl + "delete",
        type: "get",
    },
    get:{
        url:  baseUrl + "get",
        type: "get",
    } ,
    save:{
        url:  baseUrl + "save",
        type: "post",
    } ,
    random:{
        url:  baseUrl + "random",
        type: "get",
    }
}

